import { render } from "./SelectYears.vue?vue&type=template&id=27fc8ab4&scoped=true&lang=html"
import script from "./SelectYears.vue?vue&type=script&lang=js"
export * from "./SelectYears.vue?vue&type=script&lang=js"

import "./SelectYears.vue?vue&type=style&index=0&id=27fc8ab4&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fc8ab4"]])

export default __exports__